import { render, staticRenderFns } from "./adminCampaign.vue?vue&type=template&id=946b78da&scoped=true&"
import script from "./adminCampaign.vue?vue&type=script&lang=js&"
export * from "./adminCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946b78da",
  null
  
)

export default component.exports